/* @ngInject */
const dispatchRequest = (
  $q,
  dispatchResource,
  utils,
  valueHandler,
  labels,
  errorHandler
) => {
  const self = {}

  self.getBySearch = async (_data) => {
    return $q((resolve, reject) => {
      const functionName = '$dispatch.getBySearch'
      dispatchResource.post({ action: 'search', }, { search: _data }, (res) => {
        if (res && res.success && valueHandler.isArray(res.data)) {
          const response = {
            dispatches: res.data,
            message: labels.dispatch.log.search.success(res.data.length),
            color: res.data.length === 0 ? 'orange' : 'green',
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, _data)
          reject(labels.dispatch.log.search.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.getAll = async () => {
    return self.getBySearch()
  }

  self.getById = async (id) => {
    return $q(async (resolve, reject) => {
      if (valueHandler.isEmpty(id)) {
        reject(labels.dispatch.fields.id.invalid)
      }

      try {
        const response = await self.getBySearch({ id: id, })
        const dispatches = response.dispatches

        if (dispatches.length === 1) {
          resolve(dispatches[0])
        } else if (dispatches.length === 0) {
          reject(labels.dispatch.log.search.noResultWithId)
        } else {
          reject(labels.dispatch.log.search.failed)
        }
      } catch (error) {
        reject(error)
      }
    })
  }

  self.save = (_dispatch) => {
    return $q((resolve, reject) => {
      const functionName = '$dispatch.save'

      dispatchResource.save({}, _dispatch, (res) => {
        if (res && res.success && valueHandler.isId(res.data.id)) {
          const response = {
            id: res.data.id,
            message: labels.dispatch.log.save.success,
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          if (res.code === 2) {
            reject(labels.dispatch.log.save.alreadyExists)
          } else {
            errorHandler.message(res, functionName, _dispatch)
            reject(labels.dispatch.log.save.failure)
          }
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.update = (_dispatch) => {
    return $q((resolve, reject) => {
      const functionName = '$dispatch.update'
      dispatchResource.update({ action: _dispatch.id }, _dispatch, (res) => {
        if (res && res.success) {
          const response = {
            dispatch: res.dispatch,
            message: labels.dispatch.log.update.success,
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, _dispatch)
          reject(labels.dispatch.log.update.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.delete = async (_id) => {
    return $q((resolve, reject) => {
      const functionName = '$dispatch.delete'
      dispatchResource.delete({ id: _id, }, (res) => {
        if (res && res.success) {
          resolve(labels.dispatch.log.delete.success)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, { id: _id, })
          reject(labels.dispatch.log.delete.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  return self
}

export default dispatchRequest



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/dispatch/services/request.service.js